import { z } from "zod";
import { environmentsId, projectsId, virtualInboxMessagesId, recipientType } from "../../db_gen";

const listOptions = z.object({
  limit: z.number().int().positive().max(100).default(50),
  cursor: z.string().datetime().optional(),
  includeRead: z.boolean().optional(),
  recipientType: recipientType.optional(),
  recipientTypes: z.array(recipientType).min(1).max(3).optional(),
  environmentIds: z.array(environmentsId).min(1).max(10).optional(),
  providerNames: z.array(z.string().min(1).max(100)).min(1).max(10).optional(),
  subjectQuery: z.string().min(2).max(120).optional(),
  dateRange: z
    .object({
      from: z.string().datetime().optional(),
      to: z.string().datetime().optional(),
    })
    .refine((value) => Boolean(value.from) || Boolean(value.to), {
      message: "dateRange.from or dateRange.to must be provided",
    })
    .optional(),
});

export default {
  listByEnvironment: listOptions.extend({
    environmentId: environmentsId,
  }),
  listByProject: listOptions.extend({
    projectId: projectsId,
  }),
  markAsRead: z.object({
    environmentId: environmentsId,
    messageIds: z.array(virtualInboxMessagesId).min(1),
  }),
  countUnread: z.object({
    environmentId: environmentsId,
  }),
  countUnreadByProject: z.object({
    projectId: projectsId,
  }),
};
